<template>
	<div
		id="page-container"
		class="page-header-fixed page-header-classic main-content-narrow bg-black"
	>
		<!-- Header -->
		<header id="page-header">
			<div class="content-header">
				<div class="space-x-1">
					<span>
						<img
							src="/media/logo/trc-logo-title.png"
							alt="TRC Logo"
							style="height: 40px"
						/>
					</span>
				</div>
				<div class="space-x-1">
					<inertia-link :href="route('member.home')" class="btn btn-sm btn-secondary">Home</inertia-link>
					<div class="dropdown d-inline-block">
						<button
							type="button"
							class="btn btn-sm btn-secondary"
							id="page-header-user-dropdown"
							data-bs-toggle="dropdown"
							aria-haspopup="true"
							aria-expanded="false"
						>
							<span class="fw-semibold text-uppercase">
								{{ $page.props.user.fname }}
							</span>
							<i class="fa fa-angle-down opacity-50 ms-1"></i>
						</button>
						<div
							class="dropdown-menu dropdown-menu-md dropdown-menu-end p-0"
							aria-labelledby="page-header-user-dropdown"
						>
							<div class="p-2">
								<inertia-link
									class="dropdown-item d-flex align-items-center justify-content-between space-x-1"
									href="/member/profile"
								>
									<span>Profile</span>
									<i class="fa fa-fw fa-user opacity-25"></i>
								</inertia-link>
								<inertia-link v-if="userRole=='Member'"
									class="dropdown-item d-flex align-items-center justify-content-between space-x-1"
									href="/member/plan-details"
								>
									<span>Plan Details</span>
									<i class="fa fa-fw fa-list opacity-25"></i>
								</inertia-link>
								<inertia-link v-if="userRole=='Admin'"
									class="dropdown-item d-flex align-items-center justify-content-between space-x-1"
									href="/reset-password"
								>
									<span>Change Password</span>
									<i class="fa fa-fw fa-key opacity-25"></i>
								</inertia-link>
								<div class="dropdown-divider"></div>
								<inertia-link
									class="dropdown-item d-flex align-items-center justify-content-between space-x-1"
									:href="'/post/log-out?role='+userRole.toLowerCase()"
									method="POST"
									as="button"
								>
									<span>Sign Out</span>
									<i class="fa fa-fw fa-sign-out-alt opacity-25"></i>
								</inertia-link>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div id="page-header-loader" class="overlay-header bg-primary">
				<div class="content-header">
					<div class="w-100 text-center">
						<i class="far fa-sun fa-spin text-white"></i>
					</div>
				</div>
			</div>
		</header>
		<!-- Main container -->
		<main id="main-container">
			<slot></slot>

		</main>
		<!-- Footer -->
		<footer id="page-footer">
			<div class="content py-3">
				<div class="row fs-sm">
					<div class="col-sm-12 order-sm-1 py-1 text-center text-white">
						<a class="fw-semibold" href="#!">{{ $page.props.app.name }}</a>
						&copy; <span data-toggle="year-copy"></span>
					</div>
				</div>
			</div>
		</footer>
	</div>
</template>

<script setup>
import { onMounted, watch, ref } from 'vue'
import { useForm, usePage } from '@inertiajs/inertia-vue3'
import { createToaster } from '@meforma/vue-toaster'
import { Inertia } from '@inertiajs/inertia';

const props = defineProps({
	flash: Object,
	errors: Object,
	user: Object,
	userRole: String,
})

const toast = createToaster();


watch(
	() => props.flash,
	(flash) => {
		if (flash && flash.toast && flash.toast.type!="default") {
			toast.show(flash.toast.msg, { type: flash.toast.type})
		}
	}
)
</script>
